import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  public languages: string[] = ['en', 'es', 'de'];

  constructor(public translate: TranslateService, @Inject(PLATFORM_ID) private platformId: Object) {
    let browserLang;
    translate.addLangs(this.languages);

    if (isPlatformBrowser(this.platformId) && localStorage.getItem('lang')) {
      browserLang = localStorage.getItem('lang');
    } else {
      browserLang = translate.getBrowserLang();
    }
    const finalLang = browserLang?.match(/en|es|de/) ? browserLang.substring(0, 2) : 'es';
    translate.use(finalLang);
  }

  public setLanguage(lang) {
    this.translate.use(lang);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('lang', lang);
    }
  }
}
